import { cn } from "@/lib/utils";
import React from "react";

export type BadgeVariant =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "primary"
  | "secondary"
  | "danger";

interface BadgeProps {
  className?: string;
  label?: string;
  variant?: BadgeVariant;
  onClick?: () => void;
  "data-testid"?: string;
  "data-invalid"?: boolean;
  icon?: React.ReactNode;
}

const Badge = ({
  className,
  label,
  variant = "success",
  onClick,
  "data-testid": dataTestId,
  "data-invalid": dataInvalid,
  icon,
}: BadgeProps) => {
  const badgeStyles = {
    success: "bg-[#CFFFE7] text-[#116E41]",
    warning: "bg-[#FFEED0] text-[#A54D00]",
    error: "bg-[#FEE4E5] text-[#B8000B]",
    danger: "bg-[#FEE4FD] text-[#8619A0]",
    primary: "bg-[#CEFBF6] text-[#185B6E]",
    secondary: "bg-[#DEEEFE] text-[#1041A6]",
    info: "bg-[#EDEAFF] text-[#7e22ce]",
  };

  return (
    <div
      data-testid={dataTestId}
      data-invalid={dataInvalid}
      onClick={onClick}
      className={cn(
        "flex h-8 w-fit cursor-pointer items-center justify-center gap-1 rounded-md px-2 text-[13px] font-medium",
        badgeStyles[variant],
        className
      )}
    >
      <span>{icon}</span>
      <span>{label}</span>
    </div>
  );
};

export default Badge;
